import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Status, StatusUpdate } from './status.interface';

@Injectable({
    providedIn: 'root'
})
export class StatusService {
    private basePath = environment.interop.basePath;

    private findUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.find;
    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.list;
    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.delete;
    private listActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.listActive;
    private listPublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.listPublic;
    private updateActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.updateActive;
    private updatePublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.updatePublic;

    private changeStatusArhivaUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.updateArchive;

    private updateOrderUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.status.updateOrder;

    constructor(private http: HttpClient) { }

    find(id: number) {
        return this.http.get(this.findUrl + id);
    }

    list() {
        return this.http.get(this.listUrl);
    }

    add(status: Status) {
        return this.http.post(this.storeUrl, status);
    }

    update(status: StatusUpdate) {
        return this.http.put(this.updateUrl, status);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    listActive() {
        return this.http.get(this.listActiveUrl);
    }

    listPublic() {
        return this.http.get(this.listPublicUrl);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.updateActiveUrl + id, {});
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.updatePublicUrl + id, {});
    }

    changeStatusArhiva(id: number) {
        return this.http.put(this.changeStatusArhivaUrl + id, {});
    }

    updateOrder(id: number, data: any) {
        return this.http.put(this.updateOrderUrl + id, data);
    }
}
